import { useEffect, useState } from 'react';

import { PrimaryButton } from 'components/Button';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';
import { scrollToTop } from 'utils/scroll';

export function SearchButton() {
  const [searchButtonReady, setSearchButtonReady] = useState(false);

  const { isEnvironmentLoaded } = useUserEnvironment();

  useEffect(() => {
    setSearchButtonReady(isEnvironmentLoaded);
  }, [isEnvironmentLoaded]);

  return (
    <PrimaryButton
      icon={{ type: 'normalized', name: 'search' }}
      fullWidth
      type="submit"
      data-qa-id="search-button"
      dataReady={searchButtonReady}
      onClick={scrollToTop}
    >
      {getText('Search')}
    </PrimaryButton>
  );
}
